import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
 // context
import config from '../config';
 // css
import './Navigation.css';

class Navigation extends Component {
    constructor(props) {
        super(props);
        this.state = {};

        // kaita! Windowは開くが、なぜかレコード画面の読み込みでエラーが発生するので。
        this.calendarWindow = null;  // ここで calendarWindow プロパティを定義
        this.openCalendarWindow = this.openCalendarWindow.bind(this); // メソッドをバインド
        //kokomade


    }

    render() {
        return (
            <nav className="navbar navbar-expand navbar-dark bg-dark">
                <div className="container">
                    <div className="navbar-nav">
                        <NavLink exact to="/" className="nav-item nav-link" activeClassName="active" onClick={this.openCalendarWindow}>打刻画面</NavLink>
                        <NavLink to="/calendar" className="nav-item nav-link" activeClassName="active" onClick={this.openCalendarWindow}>打刻履歴</NavLink>
                    </div>
                    <div className="navbar-nav ml-auto">
                        <span className="navbar-text sm-username">{this.props.userID}</span>
                    </div>
                </div>
            </nav>
        );
    }

    openCalendarWindow(e) {
        e.preventDefault();
        // classList使用可ならclassList.contains()でOK
        if (e.target.getAttribute('class').indexOf('active') !== -1) return;

        if(this.calendarWindow == null || this.calendarWindow.closed) {
            this.calendarWindow = window.open(`#/calendar`, 'calendar', 'width=800,height=600');
        } else {
            this.calendarWindow.location.reload(true);
        }
        this.calendarWindow.focus();
    }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation.js